import axios from "axios";

export const createMeeting = async (payload = {}) => {
  const response = await axios.post(
    `${process.env.REACT_APP_SERVER_URI}/api/meetings/create`,
    payload
  );

  const meetingId = response.data?.meetingId;
  if (!meetingId) {
    throw new Error(response.data?.error || "Unable to create meeting.");
  }

  return meetingId;
};

export const createParticipantToken = async (
  userToken,
  meetingId,
  payload = {}
) => {
  const response = await axios.post(
    `${process.env.REACT_APP_SERVER_URI}/api/meetings/${meetingId}/participants`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

  const authToken = response.data?.authToken;
  if (!authToken) {
    throw new Error(
      response.data?.error || "Unable to create participant token."
    );
  }

  return authToken;
};
